import IntroStep from "./IntroStep";
import OTPVerifyStep from "./OTPVerifyStep";
import QRCodeStep from "./QRCodeStep";
import SuccessStep from "./SuccessStep";
import { useSetupTwoFAStore } from './useSetupTwoFAStore';

const SetupTwoFA = () => {
  const step = useSetupTwoFAStore((s) => s.step);
  const nextStep = useSetupTwoFAStore((s) => s.nextStep);
  const prevStep = useSetupTwoFAStore((s) => s.prevStep);
  const successSetupTwoFA = useSetupTwoFAStore((s) => s.successSetupTwoFA);

  return (
    <>
      {step === 'intro' && <IntroStep onNext={nextStep} />}
      {step === 'qr' && <QRCodeStep onNext={nextStep} />}
      {step === 'verify' && <OTPVerifyStep onPrev={prevStep} onNext={nextStep} />}
      {step === 'success' && <SuccessStep onSuccess={successSetupTwoFA} />}
    </>
  );
};

export default SetupTwoFA;
